var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvantiGreenKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004F59;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FF4713;}\n\t.st3{fill:#752420;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KEY"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MAP"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 230,
    cy: 230,
    r: 160
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "290,245.88 281.75,254.1 230.17,202.34 178.22,254.11 170,245.87 230.2,185.87  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvantiGreenKey);
export default __webpack_public_path__ + "static/media/avanti-green-key.bb9cf9661e1fa0ff175fa179497e47d3.svg";
export { ForwardRef as ReactComponent };